import { Api } from '@/services/Api'

export default {
  fetchTemplates() {
    return Api().get(`api/v2/advance-report/template`)
  },
  fetchPlantTemplate(plantId) {
    return Api().get(`api/v2/advance-report/template/${plantId}`)
  },
  deleteTemplate(plantId) {
    return Api().delete(`api/v2/advance-report/template/${plantId}`)
  },
  insertTemplates(param) {
    return Api().post(`api/v2/advance-report/template`, param)
  },
  updateTemplates(param) {
    return Api().put(`api/v2/advance-report/template`, param)
  },
  fetchPlants() {
    return Api().get(`api/v2/plant`)
  }
}
